import { useTranslation } from 'react-i18next';

import { useLazyQuery } from '@apollo/client/react';

import { LineMessageItemInput } from '@anyx/common-graphql';
import { toast } from '@anyx/shared-ui';
import { reportAppError } from '@anyx/shared-utils';

import { SERIALIZE_DRAFT_UNIT_MESSAGE } from '../graphql';

interface UseSerializeDraftUnitMessageProps {
  hideToast: boolean;
}

export const useSerializeDraftUnitMessage = (props?: UseSerializeDraftUnitMessageProps) => {
  const { t } = useTranslation('crm');
  const [serializeQuery, { loading }] = useLazyQuery(SERIALIZE_DRAFT_UNIT_MESSAGE);

  const serializeDraftUnitMessage = async ({
    name,
    messageItems,
  }: {
    name: string;
    messageItems: LineMessageItemInput[];
  }) => {
    try {
      const { data, error } = await serializeQuery({
        variables: {
          input: {
            name,
            messageItems,
          },
        },
      });

      if (error || !data?.GenerateDraftUnitMessageContent) throw error;

      if (!props?.hideToast) {
        toast.success(t('crm.line.notify.draftUnitMessage.save.success'));
      }
      return data?.GenerateDraftUnitMessageContent ?? undefined;
    } catch (error) {
      toast.error(t('crm.line.notify.draftUnitMessage.save.error'));
      reportAppError(error);
      return undefined;
    }
  };

  return {
    serializeDraftUnitMessage,
    isSerializing: loading,
  };
};
